import {
  ListenAdaptiveTempoAborted,
  NotifyReact,
  ReactToExerciseEventType,
  RemoveListener,
  SetAdaptiveTempoState,
} from 'Phaser/EventBus';

export class AdaptiveTempoController {
  private base: number;
  private delta: number = 0;
  private isActive: boolean = false;
  private startTimestamp: number = 0;
  private endTimestamp: number = 0;

  private onDone: (finalTempo: number) => void;
  private callbackScope: object | undefined;

  constructor(
    base: number,
    delta: number,
    onDone: (finalTempo: number) => void,
    callbackScope: object | undefined,
  ) {
    this.base = base;
    this.delta = delta;
    this.onDone = onDone;
    this.callbackScope = callbackScope;
    ListenAdaptiveTempoAborted(this.abortAdaptiveSegment.bind(this));
  }

  destroy() {
    RemoveListener(
      ReactToExerciseEventType.AdaptiveTempoAborted,
      this.abortAdaptiveSegment.bind(this),
    );
  }

  startAdaptiveSegment(
    base: number,
    delta: number,
    startTimestamp: number,
    endTimestamp: number,
    isBottomPhrase: boolean,
  ) {
    console.debug('[ata] startAdaptiveSegment', base, delta, startTimestamp, endTimestamp);
    this.base = base;
    this.delta = delta;
    this.startTimestamp = startTimestamp;
    this.endTimestamp = endTimestamp;
    this.isActive = true;
    NotifyReact(
      SetAdaptiveTempoState({ state: 'started', value: Math.sign(delta), isBottomPhrase }),
    );
  }

  finishAdaptiveSegment() {
    console.debug('[ata] finishAdaptiveSegment', this.base + this.delta);
    this.isActive = false;
    this.base = this.base + this.delta;
    NotifyReact(SetAdaptiveTempoState({ state: 'completed', value: this.base }));
    this.onDone.call(this.callbackScope, this.base);
  }

  abortAdaptiveSegment() {
    NotifyReact(SetAdaptiveTempoState({ state: 'aborted', value: this.base }));
    this.onDone.call(this.callbackScope, this.base);
  }

  onTick(currentTimestamp: number) {
    /*console.debug(
      '[ata] onTick',
      currentTimestamp,
      this.isActive,
      this.startTimestamp,
      this.endTimestamp,
    );*/
    if (!this.isActive) return;
    const progress =
      (currentTimestamp - this.startTimestamp) / (this.endTimestamp - this.startTimestamp);
    const newTempo = this.base + this.delta * progress;
    if (progress >= 1) {
      this.finishAdaptiveSegment();
    }
    NotifyReact(SetAdaptiveTempoState({ state: 'progress', value: newTempo }));
    return newTempo;
    //NotifyReact(UpdateTempo(newTempo));
  }
}
